<template>
  <header class="header-global">
    <base-nav class="navbar-main" transparent type="" effect="light" expand>
      <router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
        <img src="img/brand/white.png" alt="logo" />
      </router-link>

      <div class="row" slot="content-header" slot-scope="{ closeMenu }">
        <div class="col-6 collapse-brand">
          <router-link href="/">
            <img src="img/brand/blue.png" />
          </router-link>
        </div>
        <div class="col-6 collapse-close">
          <close-button @click="closeMenu"></close-button>
        </div>
      </div>

      <ul class="navbar-nav navbar-nav-hover align-items-lg-center">
        <base-dropdown class="nav-item" menu-classes="dropdown-menu-xl">
          <a
            slot="title"
            href="#"
            class="nav-link"
            data-toggle="dropdown"
            role="button"
          >
            <i class="ni ni-ui-04 d-lg-none"></i>
            <span class="nav-link-inner--text">Sobre</span>
          </a>
          <div class="dropdown-menu-inner">
            <router-link to="/profile" class="media d-flex align-items-center">
              <div
                class="icon icon-shape bg-gradient-primary rounded-circle text-white"
              >
                <i class="ni ni-spaceship"></i>
              </div>
              <div class="media-body ml-3">
                <h6 class="heading text-primary mb-md-1">Quem sou eu</h6>
                <p class="description d-none d-md-inline-block mb-0">
                  Veja um pouco sobre mim aqui. Meus lazeres, hobbies e muito
                  mais!
                </p>
              </div>
            </router-link>
            <router-link
              to="/portifolio"
              class="media d-flex align-items-center"
            >
              <div
                class="icon icon-shape bg-gradient-warning rounded-circle text-white"
              >
                <i class="ni ni-ui-04"></i>
              </div>
              <div class="media-body ml-3">
                <h5 class="heading text-warning mb-md-1">Portifólio</h5>
                <p class="description d-none d-md-inline-block mb-0">
                  Projetos que já participei ou desenvolvi do zero!
                </p>
              </div>
            </router-link>
          </div>
        </base-dropdown>
        <router-link to="/contact" class="nav-link" role="button">
          <i class="ni ni-collection d-lg-none"></i>
          <span class="nav-link-inner--text">Contato</span>
        </router-link>
        <router-link to="/articles" class="nav-link" role="button">
          <i class="ni ni-collection d-lg-none"></i>
          <span class="nav-link-inner--text">Artigos</span>
        </router-link>
      </ul>

      <ul class="navbar-nav align-items-lg-center ml-lg-auto">
        <li class="nav-item">
          <a
            class="nav-link nav-link-icon"
            href="https://www.facebook.com/leandrocantiero1"
            target="_blank"
            rel="noopener"
            data-toggle="tooltip"
            title="Me siga no Facebook"
          >
            <i class="fa fa-facebook-square"></i>
            <span class="nav-link-inner--text d-lg-none">Facebook</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link nav-link-icon"
            href="https://www.instagram.com/leandrocampag40"
            target="_blank"
            rel="noopener"
            data-toggle="tooltip"
            title="Me siga no Instagram"
          >
            <i class="fa fa-instagram"></i>
            <span class="nav-link-inner--text d-lg-none">Instagram</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link nav-link-icon"
            href="https://github.com/makinado?tab=repositories"
            target="_blank"
            rel="noopener"
            data-toggle="tooltip"
            title="Veja meu Github"
          >
            <i class="fa fa-github"></i>
            <span class="nav-link-inner--text d-lg-none">Github</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link nav-link-icon"
            href="https://www.linkedin.com/in/leandro-cantiero-288bb5179/"
            target="_blank"
            rel="noopener"
            data-toggle="tooltip"
            title="Veja meu Linkedin"
          >
            <i class="fa fa-linkedin"></i>
            <span class="nav-link-inner--text d-lg-none">Linkedin</span>
          </a>
        </li>
        <!-- <li class="nav-item d-none d-lg-block ml-lg-4">
          <a
            href="https://www.creative-tim.com/product/vue-argon-design-system"
            target="_blank"
            rel="noopener"
            class="btn btn-neutral btn-icon"
          >
            <span class="btn-inner--icon">
              <i class="fa fa-sign-in mr-2"></i>
            </span>
            <span class="nav-link-inner--text">Entrar</span>
          </a>
        </li> -->
      </ul>
    </base-nav>
  </header>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from "@/components/CloseButton";

export default {
  components: {
    BaseNav,
    CloseButton,
    BaseDropdown,
  },
};
</script>
<style>
</style>
